import { useState } from 'react';
import { SuppliersPage, SupplierVisitsPage } from '@/modules/suppliers';
import { useCurrentRoleSubjectPermission } from '@/modules/suppliers/ui/hooks/useCurrentRoleSubjectPermission';
import { useI18n } from '@/shared/i18n';
import { useAbility } from '@/modules/identity/application/ability';

type Tab = 'directory' | 'visits';

export const Suppliers = () => {
  const { t } = useI18n();
  const ability = useAbility();
  const { canRead: canReadVisit, canCreate: canCreateVisit } = useCurrentRoleSubjectPermission('SupplierVisit');
  const canViewVisits = ability.can('manage', 'all')
    || ability.can('manage', 'SupplierVisit')
    || ability.can('read', 'SupplierVisit')
    || canReadVisit
    || canCreateVisit;
  const [activeTab, setActiveTab] = useState<Tab>('directory');

  // If user can only see directory, just show the page without tabs
  if (!canViewVisits) {
    return <SuppliersPage />;
  }

  return (
    <div>
      {/* Tab Navigation */}
      <div className="border-b border-slate-200 bg-white sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex gap-4">
            <button
              onClick={() => setActiveTab('directory')}
              className={`py-3 px-1 border-b-2 transition-colors ${
                activeTab === 'directory'
                  ? 'border-primary-600 text-primary-600 font-medium'
                  : 'border-transparent text-slate-500 hover:text-slate-700'
              }`}
            >
              {t('suppliers.directory')}
            </button>
            <button
              onClick={() => setActiveTab('visits')}
              className={`py-3 px-1 border-b-2 transition-colors ${
                activeTab === 'visits'
                  ? 'border-primary-600 text-primary-600 font-medium'
                  : 'border-transparent text-slate-500 hover:text-slate-700'
              }`}
            >
              {t('suppliers.visits')}
            </button>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'directory' && <SuppliersPage />}
      {activeTab === 'visits' && <SupplierVisitsPage />}
    </div>
  );
};
